import { BaseResultsView } from "./BaseResultsView";
import { FlowView } from "./ResultTypes/FlowView";
import { ListView } from "./ResultTypes/ListView";

export class Ls2pacResultsView extends BaseResultsView {
  constructor(options) {
    super($.extend(true, {}, options));
  }
  loadResults(event, onChangeViewEvent) {
    this.createResultTypeViews();
    $.each(this.resultTypeViews, function (index, view) {
      view.loadResults(event, onChangeViewEvent);
    });
  }
  createResultTypeViews() {
    if (this.resultTypeViews.length == 0) {
      var baseOpts = {
        id: this.resultsId,
        databaseConfig: this.databaseConfig,
      };
      this.resultTypeViews.push(new ListView(baseOpts));
      this.resultTypeViews.push(new FlowView(baseOpts));
    }
  }
}
